import { CircularProgress } from '@rmwc/circular-progress';
import "@rmwc/circular-progress/styles";

export const CircularSpinner = props => <CircularProgress {...props} />